import { Component, OnDestroy, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ExtensionsService } from '../../_services/extensions.service';
import { ExtensionsDetailComponent } from '../extensions-detail/extensions-detail.component';
import { DialogService } from 'primeng/dynamicdialog';
import { VOIPService } from '../../_services/voip.service';
import { User } from 'src/app/modules/users/_types/user';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
    selector: 'app-extensions-list',
    templateUrl: './extensions-list.component.html',
    styleUrls: ['./extensions-list.component.css'],
    host: { class: 'list-page' },
    standalone: false
})
export class ExtensionsListComponent implements OnInit, OnDestroy {
  public extensions: any = [];
  public users: User[] = [];
  public endpointStatus: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    extenOrDescription: new OrFilter([
      new Filter(FilterOperation.contains, 'exten'),
      new Filter(FilterOperation.contains, 'description'),
    ])
  };
  private loadStatusTimeout: any;

  constructor(
    public topbarService: TopbarService, 
    private extensionsService: ExtensionsService,
    private usersService: UsersService,
    private dialogService: DialogService,
    private voipService: VOIPService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
  }

  ngOnInit() {
    this.topbarService.setTitle("Extensiones");
  }

  ngOnDestroy() {
    if (this.loadStatusTimeout) {
      clearTimeout(this.loadStatusTimeout);
    }
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      sort: ['exten'],
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    this.filters.extenOrDescription.filters[1].value = this.filters.extenOrDescription.filters[0].value;
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.extensionsService.all(params));
    this.extensions = response.data.filter((item: any) => item.userId!=null);
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
    this.loadUsers();
    this.loadStatus();
  }

  async loadStatus(){
    let response = await firstValueFrom(this.voipService.pjsipShowEndpoints());
    this.endpointStatus = response;
    this.extensions.forEach((extension: any) => {
      let status = this.endpointStatus.find((item: any) => item.userId === extension.userId)?.status || 'unknown';
      let state = this.voipService.getEndpointsStates().find((item: any) => item.value === status);
      extension.status = state?.label || 'Desconocido';
      extension.severity = state?.severity || 'info';
    });
    this.loadStatusTimeout = setTimeout(() => {
      this.loadStatus();
    }, 10 * 1000);
  }

  async loadUsers(){
    let params: IParamsCollection = {
      page: { number: 1, size: 1000 },
    };
    let response = await firstValueFrom(this.usersService.all(params));
    this.users = response.data;
    this.extensions.forEach((extension: any) => {
      extension.user = this.users.find((item: any) => item.id == extension.userId);
    });
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(id: any) {
    const ref = this.dialogService.open(ExtensionsDetailComponent, {
      closable: true,
      modal: true,
      data: {
        id: id ? id : null
      },
      header: "Detalle de la extensión",
      width: '800px'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadData(this.lastGridEvent);
    });
  }

  delete(extension:any){
    console.log(extension);
    this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la extensión "+extension.name+"?",
        header: "Eliminar extensión",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.extensionsService.delete(extension.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Extensión eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
  }

}
